import i18n from '@/i18n'

export default [
  {
    path: '/reset-pwd',
    component: () => import('@/views/resetPwd/index.vue'),
    meta: {
      title: i18n.t('sign.forgetPwd')
    }
  }
]